
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/solutions/online-courses",
      function () {
        return require("private-next-pages/solutions/online-courses/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/solutions/online-courses"])
      });
    }
  